.selectContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.selectContainer label {
    font-family: var(--sans-serif);
    margin-bottom: 8px;
}

.selectWithLabel:last-child {
    flex: 1;
}

.select {
    font-family: var(--sans-serif) !important;
    width: 100%;
}

.select input {
    height: 100%;
}

.select :global(.select__indicators) {
    height: 100% !important;
}

.select :global(.select__indicator-separator) {
    display: none;
}

.select :global(.select__placeholder) {
    color: var(--ink-lighter) !important;
    font-family: var(--sans-serif) !important;
}

.select :global(.select__control) {
    width: 100%;
    border-radius: var(--border-radius) !important;
    border-color: var(--ink-lighter) !important;
    transition: all 0.1s ease-in;
    font-size: 1.6rem;
}

.select :global(.select__control--is-disabled) {
    background-color: var(--paper-dark) !important;
    color: var(--ink-light) !important;
}

.select :global(.select__control:hover:not(.select__control--is-focused)) {
    border-color: var(--ink-light) !important;
}

.select :global(.select__control--menu-is-open) {
    border-color: var(--lime) !important;
    box-shadow: 0 1px 5px rgba(18, 184, 134, 0.5) !important;
}

.select :global(.select__control--is-focused) :global(.select__single-value) {
    color: var(--ink-lighter) !important;
    top: calc(100% + 6px);
}

.select :global(.select__control--is-focused:not(.select__control--menu-is-open)) {
    box-shadow: none !important;
}

.select :global(.select__value-container) {
    height: 100% !important;
    padding-left: 16px !important;
}

.select :global(.select__menu) {
    margin-top: 0 !important;
    box-shadow: 0 1px 4px var(--ink-16) !important;
}

.select :global(.select__option) {
    position: relative;
    padding: 16px !important;
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.6rem;
}

.select :global(.select__menu-list) {
    max-height: 195px;
    padding-top: 0 !important;
}

.select :global(.select__option--is-focused),
.select :global(.select__option--is-focused):active {
    background-color: var(--paper-dark) !important;
    color: var(--ink) !important;
}

.select :global(.select__option--is-selected),
.select :global(.select__option--is-selected):active {
    font-weight: 500;
}

.select :global(.select__option--is-selected:not(:hover)),
.select :global(.select__option--is-selected:not(:hover)):active {
    background-color: var(--white) !important;
    color: var(--ink) !important;
}

.select :global(.select__multi-value) {
    background-color: var(--paper-dark);
}

.select :global(.select__multi-value__label) {
    border-radius: 4px;
    padding: 5px 8px;
}

.select :global(.select__multi-value__remove):hover {
    background-color: var(--paper-dark);
    cursor: pointer;
}

.select :global(.select__multi-value__remove):hover rect {
    fill: var(--ink-light);
}

.select :global(.select__menu-list--is-multi) label {
    margin-bottom: 0;
}

.select :global(.select__menu-list--is-multi) input[type='checkbox']:checked + label:before {
    align-items: normal;
}
